/**
 *  유저 상세 > 주문 정보 > 포인트 내역 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  포인트 내역 종류
   */
  type: null,
  /**
   *  포인트 적립/사용처
   */
  pointCauseId: null,
  /**
   *  포인트 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

export const POINT_GENERATE_VALID_RESULT_MODEL = {
  requestCnt: null,
  possibleCnt: null,
  impossibleCnt: null,
  userPointList: [],
  pointCauseSelectList: [],
  isBulk: null,
};
